"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CloseButton_1 = __importDefault(require("~/components/common/controls/CloseButton"));
const useClickOutsideHandler_1 = __importDefault(require("~/hooks/useClickOutsideHandler"));
const utils_1 = require("~/utils/utils");
const Image_1 = __importDefault(require("../Image"));
const consts_1 = require("./consts");
const InformationBanner_scss_1 = __importDefault(require("./InformationBanner.scss"));
function InformationBanner({ imageName = '', redirectUrl = '', isClosable = true }) {
    const [isOpened, setIsOpened] = (0, react_1.useState)(true);
    const wrapperRef = (0, react_1.useRef)(null);
    const elementRef = (0, react_1.useRef)(null);
    const hideBanner = (hard = false) => {
        if (isClosable || hard) {
            setIsOpened(false);
        }
    };
    (0, useClickOutsideHandler_1.default)(wrapperRef, elementRef, hideBanner);
    const checkEndDate = () => {
        const date = new Date(consts_1.END_DATE.year, consts_1.END_DATE.month - 1, consts_1.END_DATE.day);
        date.setUTCHours(8); // 00:00 in PST
        const endTimestamp = date.getTime();
        const currentTimestamp = Date.now();
        if (currentTimestamp > endTimestamp) {
            hideBanner(true);
        }
    };
    (0, react_1.useEffect)(() => {
        checkEndDate();
    }, []);
    const currentImageName = imageName || consts_1.IMAGE_NAME;
    const currentRedirectUrl = redirectUrl || consts_1.REDIRECT_URL;
    const imageSrc = `${consts_1.PATH_TO_IMAGES}${currentImageName}`;
    const closeHandler = () => {
        hideBanner();
    };
    const clickHandler = () => {
        hideBanner();
    };
    return (react_1.default.createElement("div", null, isOpened && (react_1.default.createElement("div", { className: InformationBanner_scss_1.default.container, ref: wrapperRef },
        isClosable && (react_1.default.createElement("div", { className: InformationBanner_scss_1.default.closeButton },
            react_1.default.createElement(CloseButton_1.default, { onCLickHandler: closeHandler }))),
        react_1.default.createElement("div", { ref: elementRef },
            react_1.default.createElement("a", { href: currentRedirectUrl, target: "_blank", rel: "noreferrer", onClick: clickHandler },
                react_1.default.createElement(Image_1.default, { src: (0, utils_1.formatAssetsURL)(imageSrc), className: InformationBanner_scss_1.default.bannerImage })))))));
}
exports.default = InformationBanner;
